export const moviesB = [
  {
    id: "m19",
    title: "蓝色星球计划",
    year: 2024,
    releaseDate: "2024-06-14",
    region: "日本",
    types: ["科幻", "动画", "冒险"],
    director: "中村圭",
    cast: ["早见沙织", "石川界人"],
    duration: 118,
    rating: 8.8,
    views: 693000,
    poster: "https://readdy.ai/api/search-image?query=deep%20ocean%20research%20submersible%20exploring%20glowing%20reef%2C%20anime%20sci-fi%20poster%20art%2C%20vivid%20deep%20navy%20water%20and%20warm%20bioluminescent%20orange%2C%20no%20text&width=600&height=900&seq=movie-poster-19&orientation=portrait",
    summary: "当海面不再有光，一群少年驾驶潜艇去找最后一片珊瑚。",
    synopsis: "海平面上升后的第三十年，人类把城市迁往高处，海洋成为禁区。深海研究少年班的成员在一次训练中收到求救信号，信号来自早已废弃的海底观测站，编号正是他们导师的名字。",
    news: [
      { title: "《蓝色星球计划》公布海洋设定集，细节考据获好评", date: "2024-05-28" },
      { title: "中村圭新作票房破纪录，深海场景全手绘", date: "2024-06-20" },
    ],
  },
  {
    id: "m20",
    title: "情书未寄",
    year: 2025,
    releaseDate: "2025-02-21",
    region: "中国香港",
    types: ["爱情", "剧情", "悬疑"],
    director: "叶之秋",
    cast: ["陈伊", "苏航", "黎曼"],
    duration: 107,
    rating: 8.0,
    views: 457000,
    poster: "https://readdy.ai/api/search-image?query=rain%20blurred%20window%20with%20handwritten%20letter%20and%20two%20hands%2C%20cinematic%20romance%20poster%2C%20soft%20amber%20light%20and%20deep%20navy%20shadows%2C%20delicate%20mood%2C%20no%20text&width=600&height=900&seq=movie-poster-20&orientation=portrait",
    summary: "一封迟到十五年的信，把两个早已走散的人重新拉回同一场雨。",
    synopsis: "整理母亲遗物时，阿岚发现了一叠从未寄出的信，收件人是一个陌生男人的名字。她按地址找到旧楼，那里住着的却是自己高中时最好的朋友。两个人一起读完这些信，才发现当年的离别另有原因。",
    news: [
      { title: "《情书未寄》情人节档口碑稳健，长镜头获赞", date: "2025-02-24" },
      { title: "叶之秋谈爱情片：不是遗憾，是终于说出口", date: "2025-02-10" },
    ],
  },
  {
    id: "m21",
    title: "龙脊行动",
    year: 2026,
    releaseDate: "2026-06-05",
    region: "中国大陆",
    types: ["动作", "冒险", "剧情"],
    director: "冯铸",
    cast: ["韩野", "林傲", "罗小北"],
    duration: 133,
    rating: 8.4,
    views: 873000,
    poster: "https://readdy.ai/api/search-image?query=mountain%20rescue%20team%20silhouettes%20on%20snowy%20ridge%20with%20helicopter%20light%2C%20cinematic%20action%20poster%2C%20navy%20alpine%20shadows%20and%20amber%20beam%2C%20no%20text&width=600&height=900&seq=movie-poster-21&orientation=portrait",
    summary: "雪崩封山后的第十九个小时，救援队只剩下一次上行的机会。",
    synopsis: "龙脊雪山发生大规模雪崩，一支科考队失联。山地救援队在能见度不足五米的暴风雪中出发，唯一的路线必须经过三年前夺走他们队友生命的北壁。队长的决定，让整支队伍开始怀疑这次行动真正的目的。",
    news: [
      { title: "《龙脊行动》实景雪山大场面曝光，拍摄海拔超四千米", date: "2026-04-22" },
      { title: "冯铸新作聚焦山地救援，专业顾问全程跟组", date: "2026-05-19" },
    ],
  },
  {
    id: "m22",
    title: "空房间的猫",
    year: 2024,
    releaseDate: "2024-03-15",
    region: "日本",
    types: ["动画", "剧情", "爱情"],
    director: "松本悠",
    cast: ["广濑真", "绪方拓"],
    duration: 99,
    rating: 8.7,
    views: 372000,
    poster: "https://readdy.ai/api/search-image?query=small%20cat%20sitting%20in%20sunlit%20empty%20room%20with%20dust%20motes%2C%20hand%20painted%20anime%20poster%2C%20warm%20cream%20light%2C%20soft%20navy%20shadows%2C%20gentle%20mood%2C%20no%20text&width=600&height=900&seq=movie-poster-22&orientation=portrait",
    summary: "一只猫守着搬空的房子，等一个不会再回来的人。",
    synopsis: "画家去世后，他的房子被清空，只剩一只老猫住在空荡荡的客厅里。每天下午三点，阳光会照在墙上原来的画框位置。来整理遗物的年轻人渐渐发现，房子里的每一道光、每一处磨痕，都是一幅没画完的画。",
    news: [
      { title: "《空房间的猫》治愈系口碑扩散，重映场次加开", date: "2024-04-08" },
      { title: "松本悠：全片只有三十七句对白", date: "2024-03-10" },
    ],
  },
  {
    id: "m23",
    title: "城市之光手记",
    year: 2025,
    releaseDate: "2025-11-14",
    region: "中国大陆",
    types: ["剧情", "悬疑", "爱情"],
    director: "程可",
    cast: ["何知远", "白桃", "姜维"],
    duration: 116,
    rating: 7.9,
    views: 528000,
    poster: "https://readdy.ai/api/search-image?query=writer%20at%20desk%20by%20tall%20window%20overlooking%20night%20city%2C%20cinematic%20drama%20poster%2C%20amber%20desk%20lamp%20and%20deep%20navy%20skyline%2C%20no%20text&width=600&height=900&seq=movie-poster-23&orientation=portrait",
    summary: "一个写字的人，在深夜的城市里捡到了别人的人生片段。",
    synopsis: "专栏作者周迟靠写城市观察谋生，某天他在便利店捡到一本陌生人遗落的手记，里面记录的时间与地点，正好对应近期几起无人报案的失窃。他一边追踪手记的主人，一边把自己的生活写进了下一篇稿子里。",
    news: [
      { title: "《城市之光手记》聚焦都市写作群体，首映获好评", date: "2025-11-02" },
      { title: "程可：城市里最动人的故事都在便利店发生", date: "2025-10-26" },
    ],
  },
  {
    id: "m24",
    title: "大笑江湖传",
    year: 2023,
    releaseDate: "2023-08-11",
    region: "中国大陆",
    types: ["喜剧", "冒险", "动作"],
    director: "郭大成",
    cast: ["马腾", "施一鸣", "柳青"],
    duration: 111,
    rating: 7.4,
    views: 604000,
    poster: "https://readdy.ai/api/search-image?query=comic%20swordsman%20posing%20on%20ancient%20inn%20rooftop%20with%20flying%20leaves%2C%20cinematic%20wuxia%20comedy%20poster%2C%20warm%20amber%20sunset%20and%20deep%20navy%20sky%2C%20no%20text&width=600&height=900&seq=movie-poster-24&orientation=portrait",
    summary: "一个只会三招的厨子，被整个江湖当成了绝世高手。",
    synopsis: "客栈厨子阿福意外救下重伤的剑客，从此被误认成隐世高手。各路人马接连上门挑战，他只能靠菜刀、锅铲和一点点运气应付。当一个真正的高手出现时，他决定用最后一道菜解决问题。",
    news: [
      { title: "《大笑江湖传》暑期档喜剧表现亮眼，二刷观众增多", date: "2023-08-20" },
      { title: "郭大成：武侠喜剧难拍，但值得试一次", date: "2023-08-02" },
    ],
  },
  {
    id: "m25",
    title: "记忆裂缝",
    year: 2026,
    releaseDate: "2026-07-24",
    region: "美国",
    types: ["科幻", "悬疑", "动作"],
    director: "朱莉娅·罗斯",
    cast: ["本·米尔顿", "艾娃·凯恩"],
    duration: 129,
    rating: 8.5,
    views: 962000,
    poster: "https://readdy.ai/api/search-image?query=fractured%20face%20portrait%20with%20glowing%20memory%20fragments%2C%20cinematic%20sci-fi%20thriller%20poster%2C%20deep%20navy%20with%20amber%20light%20leaks%2C%20abstract%20surreal%20composition%2C%20no%20text&width=600&height=900&seq=movie-poster-25&orientation=portrait",
    summary: "他每天醒来都少一段记忆，而少掉的正好都是同一个人。",
    synopsis: "记忆修复师凯尔接下一个特殊委托：一位客户要求删除自己生命中某个人存在的所有痕迹。手术成功后，凯尔却开始在自己的记忆里看见那个被删除的人。为了弄清真相，他给自己做了一次未经批准的回溯。",
    news: [
      { title: "《记忆裂缝》预告片单日播放破千万，概念海报引热议", date: "2026-05-30" },
      { title: "朱莉娅·罗斯谈新片：记忆是我们唯一无法备份的东西", date: "2026-07-08" },
    ],
  },
  {
    id: "m26",
    title: "海边的旧唱片",
    year: 2024,
    releaseDate: "2024-05-10",
    region: "法国",
    types: ["爱情", "剧情", "喜剧"],
    director: "皮埃尔·拉丰",
    cast: ["克莱尔·维拉", "朱利安·贝克"],
    duration: 114,
    rating: 8.2,
    views: 331000,
    poster: "https://readdy.ai/api/search-image?query=vintage%20record%20player%20on%20seaside%20table%20with%20view%20of%20waves%2C%20cinematic%20romance%20poster%2C%20warm%20faded%20amber%20and%20soft%20blue%20sea%2C%20fine%20film%20grain%2C%20no%20text&width=600&height=900&seq=movie-poster-26&orientation=portrait",
    summary: "一张只剩半面的唱片，让两个陌生人一起找回了夏天的声音。",
    synopsis: "旧货商在海边小镇收到一箱无人认领的黑胶唱片，其中一张只有半面有录音。他贴出寻找原主人的告示，来认领的是一位从未听过这张唱片的老太太，和一位每晚都在海边录音的年轻作曲人。",
    news: [
      { title: "《海边的旧唱片》戛纳一种关注单元获好评", date: "2024-05-18" },
      { title: "原声黑胶限量发售，半小时售罄", date: "2024-06-02" },
    ],
  },
  {
    id: "m27",
    title: "追光少年",
    year: 2025,
    releaseDate: "2025-12-12",
    region: "中国大陆",
    types: ["剧情", "喜剧", "冒险"],
    director: "郭立",
    cast: ["陈晓星", "战宇", "黄莺"],
    duration: 109,
    rating: 8.3,
    views: 443000,
    poster: "https://readdy.ai/api/search-image?query=teenager%20running%20across%20school%20track%20at%20sunset%20holding%20camera%2C%20cinematic%20coming%20of%20age%20poster%2C%20golden%20amber%20light%2C%20navy%20shadows%2C%20no%20text&width=600&height=900&seq=movie-poster-27&orientation=portrait",
    summary: "一个总跑最后一名的少年，想拍下全校最快的那个人。",
    synopsis: "高一新生小北跑得慢，却有一台父亲留下的旧相机。他决定拍摄校田径队的天才选手，记录对方冲向终点的每一刻。镜头跟着跑过整个夏天，他渐渐发现，自己想留下的并不是胜负。",
    news: [
      { title: "《追光少年》校园点映反响热烈，青春片再添佳作", date: "2025-12-01" },
      { title: "郭立：每个班都有一个跑得最慢但看得最清楚的人", date: "2025-11-20" },
    ],
  },
  {
    id: "m28",
    title: "双面玩家",
    year: 2026,
    releaseDate: "2026-08-07",
    region: "韩国",
    types: ["动作", "悬疑", "科幻"],
    director: "姜在勋",
    cast: ["李准基", "韩素拉", "金武烈"],
    duration: 127,
    rating: 8.1,
    views: 1021000,
    poster: "https://readdy.ai/api/search-image?query=dual%20silhouettes%20of%20one%20man%20in%20neon%20rain%20city%20alley%2C%20cinematic%20action%20thriller%20poster%2C%20deep%20navy%20and%20amber%20neon%20accents%2C%20no%20text&width=600&height=900&seq=movie-poster-28&orientation=portrait",
    summary: "白天是保安，夜里是顶级玩家，他却分不清哪个身份是真的。",
    synopsis: "在一款全民沉浸式竞技游戏里，排名前十的玩家可以获得一次现实中的「重置」机会。保安泰成正准备冲榜，却发现自己游戏中的搭档，竟与自己共享同一段现实记忆。两人必须在决赛中互相击败对方。",
    news: [
      { title: "《双面玩家》动作设计曝光，虚拟与现实双线拍摄", date: "2026-06-18" },
      { title: "韩素拉首次挑战动作戏，训练三个月完成长镜头", date: "2026-07-22" },
    ],
  },
  {
    id: "m29",
    title: "雪线之上",
    year: 2024,
    releaseDate: "2024-10-18",
    region: "中国大陆",
    types: ["冒险", "剧情", "动作"],
    director: "索朗",
    cast: ["扎西", "丁曦", "杨川"],
    duration: 123,
    rating: 8.6,
    views: 507000,
    poster: "https://readdy.ai/api/search-image?query=climbers%20roped%20on%20glacier%20face%20at%20sunrise%2C%20cinematic%20adventure%20poster%2C%20cold%20navy%20ice%20and%20warm%20amber%20alpenglow%2C%20no%20text&width=600&height=900&seq=movie-poster-29&orientation=portrait",
    summary: "一位老向导最后一次上山，只为把一块旧路牌挂回原处。",
    synopsis: "六十岁的向导丹增宣布退休，却在大雪封山前独自出发，要把一块被风刮走的路牌挂回海拔六千米的垭口。年轻记者跟着他上山，一路听着关于这座山的名字、事故与传说的故事。",
    news: [
      { title: "《雪线之上》高原实拍纪录片式幕后公开", date: "2024-10-08" },
      { title: "索朗导演：山不说话，但山记得所有事", date: "2024-09-30" },
    ],
  },
  {
    id: "m30",
    title: "麻烦请排队",
    year: 2025,
    releaseDate: "2025-03-28",
    region: "中国大陆",
    types: ["喜剧", "爱情", "剧情"],
    director: "沈甜",
    cast: ["吴双", "李牧", "章小鱼"],
    duration: 101,
    rating: 7.5,
    views: 611000,
    poster: "https://readdy.ai/api/search-image?query=couple%20standing%20in%20long%20queue%20at%20night%20market%2C%20playful%20cinematic%20comedy%20poster%2C%20warm%20amber%20lanterns%20and%20deep%20navy%20sky%2C%20no%20text&width=600&height=900&seq=movie-poster-30&orientation=portrait",
    summary: "一场横跨整夜的排队，让两个陌生人把一生的话说完了。",
    synopsis: "小城最火的早餐铺要搬迁，最后一夜的队伍从街口排到桥头。为了替朋友占位，内向的阿文和话很多的阿梨不得不并肩站上一整夜。队伍一点点向前挪，他们的故事也一点点被说完。",
    news: [
      { title: "《麻烦请排队》春日档黑马，排片逐日上升", date: "2025-04-06" },
      { title: "全片主要场景只有一条街，导演：限制反而自由", date: "2025-03-20" },
    ],
  },
  {
    id: "m31",
    title: "星尘旅人",
    year: 2026,
    releaseDate: "2026-02-27",
    region: "日本",
    types: ["动画", "科幻", "冒险"],
    director: "河野",
    cast: ["花泽奈", "细谷真"],
    duration: 112,
    rating: 8.8,
    views: 589000,
    poster: "https://readdy.ai/api/search-image?query=boy%20and%20comet%20spirit%20traveling%20through%20starry%20sky%2C%20hand%20painted%20anime%20poster%20art%2C%20deep%20navy%20cosmos%20with%20warm%20golden%20comet%20trail%2C%20no%20text&width=600&height=900&seq=movie-poster-31&orientation=portrait",
    summary: "一个收集星尘的少年，陪一颗迷路的彗星走完最后一程。",
    synopsis: "小镇天文台的少年阿透能看见星星掉落时留下的碎屑。某夜，一颗彗星的碎片落进他家的院子，化作一个不会说话的少年。他们一起沿着旧铁路线向北，去往彗星原本应该坠落的湖。",
    news: [
      { title: "《星尘旅人》主题曲MV公开，星空场景获赞", date: "2026-02-12" },
      { title: "河野导演新作入围动画电影节长片竞赛", date: "2026-01-30" },
    ],
  },
  {
    id: "m32",
    title: "午夜的士",
    year: 2023,
    releaseDate: "2023-12-01",
    region: "中国香港",
    types: ["悬疑", "动作", "剧情"],
    director: "刘启雄",
    cast: ["周润山", "程美", "杜峰"],
    duration: 118,
    rating: 8.4,
    views: 726000,
    poster: "https://readdy.ai/api/search-image?query=vintage%20taxi%20under%20Hong%20Kong%20night%20rain%20with%20driver%20silhouette%2C%20cinematic%20crime%20poster%2C%20amber%20sodium%20light%20and%20deep%20navy%20wet%20street%2C%20no%20text&width=600&height=900&seq=movie-poster-32&orientation=portrait",
    summary: "一个夜班司机，载上了今晚全城都在找的那个人。",
    synopsis: "开了二十年夜班的士的老陈，习惯不问客人去哪。这晚上车的男人浑身是血，只说了一个已经拆掉十年的地址。车穿过雨夜的城市，后座的乘客换了一次又一次，计价器却始终没有跳过。",
    news: [
      { title: "《午夜的士》4K修复版重映，老港片味道回来了", date: "2025-01-12" },
      { title: "刘启雄谈实拍夜戏：整条街只留一盏路灯", date: "2023-11-24" },
    ],
  },
  {
    id: "m33",
    title: "无声证词",
    year: 2025,
    releaseDate: "2025-04-25",
    region: "中国大陆",
    types: ["悬疑", "剧情", "爱情"],
    director: "沈照",
    cast: ["葛文", "秦岚青", "何知白"],
    duration: 113,
    rating: 8.2,
    views: 494000,
    poster: "https://readdy.ai/api/search-image?query=woman%20signing%20in%20shadowed%20police%20archive%20room%2C%20cinematic%20mystery%20poster%2C%20deep%20navy%20shadows%20with%20amber%20desk%20lamp%2C%20no%20text&width=600&height=900&seq=movie-poster-33&orientation=portrait",
    summary: "唯一的目击者无法开口，她用手语讲出了那个夜晚。",
    synopsis: "一起旧案重启调查，唯一的目击者是位听障女孩。手语翻译在逐句转述时，发现女孩描述的现场与卷宗记录完全不同。为了弄清哪一种叙述才是真的，她开始自己走进那段被封存的记忆。",
    news: [
      { title: "《无声证词》关注听障群体，手语顾问全程参与", date: "2025-04-14" },
      { title: "沈照新作获电影频道传媒关注单元推荐", date: "2025-04-28" },
    ],
  },
  {
    id: "m34",
    title: "逆流而上",
    year: 2026,
    releaseDate: "2026-09-18",
    region: "中国大陆",
    types: ["动作", "剧情", "冒险"],
    director: "段毅",
    cast: ["吴锋", "江月", "白宇"],
    duration: 125,
    rating: 8.0,
    views: 358000,
    poster: "https://readdy.ai/api/search-image?query=swimmer%20emerging%20from%20dark%20river%20with%20city%20bridge%20behind%2C%20cinematic%20drama%20poster%2C%20deep%20navy%20water%20and%20amber%20sunset%20rim%20light%2C%20no%20text&width=600&height=900&seq=movie-poster-34&orientation=portrait",
    summary: "洪水来了，他要在天亮前游过整条被淹的旧城。",
    synopsis: "连日的暴雨让老城变成一片水域，退役游泳运动员阿海得知母亲被困在河对岸的老屋。救援船无法进入狭窄水道，他决定独自下水，沿着童年熟悉的那条街游回去。水面之下，是被淹没的整个过去。",
    news: [
      { title: "《逆流而上》定档国庆前，水上实拍难度曝光", date: "2026-08-02" },
      { title: "剧组搭建整条水下老街，演员完成自由潜训练", date: "2026-08-26" },
    ],
  },
  {
    id: "m35",
    title: "好好说再见",
    year: 2024,
    releaseDate: "2024-07-05",
    region: "中国大陆",
    types: ["剧情", "爱情", "喜剧"],
    director: "温可",
    cast: ["林知夏", "于洋", "刘芸"],
    duration: 106,
    rating: 8.5,
    views: 619000,
    poster: "https://readdy.ai/api/search-image?query=two%20people%20hugging%20at%20train%20platform%20with%20soft%20snow%2C%20cinematic%20drama%20poster%2C%20warm%20amber%20station%20lights%20and%20pale%20navy%20dusk%2C%20no%20text&width=600&height=900&seq=movie-poster-35&orientation=portrait",
    summary: "一对分手多年的恋人，为了送别同一只老狗再次同行。",
    synopsis: "分开五年后，方宁和程岸因为一起养过的狗生病而重新联系。他们约好一起带它回最初相遇的那座小城，路上聊工作、聊新生活，默契地不提当年。旅途的最后一站，是他们谁都没有提前说出口的地方。",
    news: [
      { title: "《好好说再见》口碑长线发力，成年观众占比高", date: "2024-07-22" },
      { title: "温可：这部电影想聊的不是复合，是告别", date: "2024-06-28" },
    ],
  },
  {
    id: "m36",
    title: "疯狂实验室",
    year: 2025,
    releaseDate: "2025-08-22",
    region: "美国",
    types: ["科幻", "喜剧", "悬疑"],
    director: "布莱恩·科特",
    cast: ["杰森·史东", "露西·怀特"],
    duration: 98,
    rating: 7.6,
    views: 841000,
    poster: "https://readdy.ai/api/search-image?query=chaotic%20laboratory%20with%20glowing%20experiment%20and%20shocked%20scientist%2C%20cinematic%20sci-fi%20comedy%20poster%2C%20navy%20shadows%20and%20warm%20amber%20accents%2C%20no%20text&width=600&height=900&seq=movie-poster-36&orientation=portrait",
    summary: "一台能把假设变成现实的机器，被两个实习生按错了按钮。",
    synopsis: "实验室里最不被看好的两个实习生，意外启动了导师封锁多年的原型机。从此他们说的每一句假设都会短暂成真，包括「如果楼下的咖啡机爆炸了」。为了在评审日之前收拾残局，他们只能继续假设下去。",
    news: [
      { title: "《疯狂实验室》发布正式预告，脑洞设定引期待", date: "2025-07-10" },
      { title: "低成本科幻喜剧意外走红，续集进入开发", date: "2025-09-15" },
    ],
  },
];